import SkillCategory from "./SkillCategory";
import User from "./User";
import Grade from './Grade.js';
import KpiWeight from './KpiWeight';
import SalaryReview from './SalaryReview';
import KpiWeightType from '../enums/KpiWeightType';

export default class Job {
  constructor(data) {
    this.id = data?.id;
    this.gradeId = data?.gradeId;
    this.name = data?.name;
    this.isSalaryReviewTarget = data?.isSalaryReviewTarget;
    this.isDeleted = data?.isDeleted;
    this.skillCategories = Array.isArray(data?.skill_categories)
      ? data.skill_categories.map(e => new SkillCategory(e))
      : [];

    this.kpiWeights = data?.kpi_weights ? data.kpi_weights : [];
    this.skillWeight = data?.skill_weight;

    this.personalGoalWeight = data?.kpiWeights ? data.kpiWeights.map((k) => new KpiWeight(k)).find(w => w.type.is(KpiWeightType.PERSONAL_GOAL)) : 0;
    this.salaryReviews = data?.salaryReviews ? data.salaryReviews.map((s) => new SalaryReview(s)) : [];
    this.grade = data?.grade ? new Grade(data?.grade) : null;
  }

  /**
   * Jobに紐づくスキルの評価において取りうる最高合計得点を返す
   *
   * @param {number} maxRankValue
   * @returns {number}
   */
  getMaxScore(maxRankValue) {
    let res = 0;
    this.skillCategories?.forEach(skillCategory => {
      skillCategory.skills?.forEach(skill => {
        res += skill.point * maxRankValue;
      });
    });
    return res ?? 0;
  }
}
